import { Link } from 'react-router-dom';
import { Compass, Home } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { GameCard } from '../components/game/GameCard';
import { featuredGames } from '../config/games';

export function NotFoundPage() {
  const suggestions = featuredGames().slice(0, 4);
  return (
    <div className="mx-auto max-w-3xl py-16 text-center">
      <p className="font-display text-7xl font-extrabold text-gradient">404</p>
      <h1 className="mt-4 text-2xl font-bold text-white">This table is closed</h1>
      <p className="mx-auto mt-2 max-w-md text-sm text-ink-300">
        The page you were looking for has left the floor. Try the lobby — the reels are still warm.
      </p>
      <div className="mt-6 flex justify-center gap-3">
        <Link to="/">
          <Button variant="primary" iconLeft={<Home className="size-4" />}>
            Back to home
          </Button>
        </Link>
        <Link to="/casino">
          <Button variant="secondary" iconLeft={<Compass className="size-4" />}>
            Browse casino
          </Button>
        </Link>
      </div>
      <div className="mt-12 grid grid-cols-2 gap-4 sm:grid-cols-4">
        {suggestions.map((game) => (
          <GameCard key={game.id} game={game} size="sm" />
        ))}
      </div>
    </div>
  );
}
